export default "__VITE_ASSET__yParKlmU__"